module.exports = "/assets/0166a96ad699d895cadddc2fdae26923.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AV.png
// module id = 1209
// module chunks = 0